import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import blogPosts from "../data/blogData";
import "./BlogPostPage.css";

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  useEffect(function () {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) return (
    <div className="not-found container">
      <h2>Post not found</h2>
      <Link to="/blog">← Back to Blog</Link>
    </div>
  );

  const related = blogPosts.filter(p => p.id !== post.id).slice(0, 3);

  return (
    <div className="blog-post-page">

      {/* HERO */}
      <div className="bp-hero">
        <img src={post.image} alt={post.title} className="bp-hero-img" />
        <div className="bp-hero-overlay" />
        <div className="bp-hero-content">
          <Link to="/blog" className="bp-back">← Back to Blog</Link>
          <span className="bp-category">{post.category}</span>
          <h1>{post.title}</h1>
          <div className="bp-meta">
            <span>{post.date}</span>
            <span className="bp-dot">·</span>
            <span>{post.readTime}</span>
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="bp-content container">
        <div className="bp-article">
          {post.content.split("\n\n").map(function (para, i) {
            if (!para.trim()) return null;
            return <p key={i}>{para}</p>;
          })}
        </div>
      </div>

      {/* RELATED */}
      {related.length > 0 && (
        <div className="bp-related container">
          <div className="eyebrow" style={{ marginBottom: 32 }}>
            <div className="eline"></div>
            <span className="etxt">More Stories</span>
          </div>
          <div className="bp-related-grid">
            {related.map(function (r) {
              return (
                <Link to={"/blog/" + r.slug} key={r.id} className="bp-related-card">
                  <div className="bp-related-img">
                    <img src={r.image} alt={r.title} />
                  </div>
                  <div className="bp-related-body">
                    <span className="bp-related-cat">{r.category}</span>
                    <h3>{r.title}</h3>
                    <p>{r.intro.substring(0, 100)}...</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      )}

    </div>
  );
}
